<style>
</style>
<template>
  <div>
    <v-card flat>
      <v-data-table class="elevation-0" :headers="headers" :items="basketItems" item-key="itemId"
                    :footer-props="{ itemsPerPageOptions }">
        <template v-slot:item.itemName="{ item }">{{ item.itemName }}<br><small>{{ item.itemDesc }}</small></template>
        <template v-slot:item.price="{ item }">{{ item.useCredit ? item.creditPrice : item.price | currency }}
          <br><small>{{ item.useCredit ? $t('Kredit') : $t('Cena') }}</small>
        </template>
        <template v-slot:item.volume="{ item }">
          <div v-if="item.canChangeVolume">
            <v-tooltip bottom>
            <span>{{ $t('Snížit množství') }}</span>
            <template v-slot:activator="{ on }">
              <v-btn icon @click.native.stop="decrementItem(item)" v-on="on">
                <v-icon dark>mdi-minus-circle-outline</v-icon>
              </v-btn>
            </template>
          </v-tooltip>
            <div class="d-inline-flex">{{ item.volume }} {{ 'ks' }}</div>
          <v-tooltip bottom>
            <span>{{ $t('Zvýšit množství') }}</span>
            <template v-slot:activator="{ on }">
              <v-btn icon @click.native.stop="incrementItem(item)" v-on="on">
                <v-icon dark>mdi-plus-circle-outline</v-icon>
              </v-btn>
            </template>
          </v-tooltip>
          </div>
          <div v-else>
            {{ item.volume }} {{ 'ks' }}
          </div>
        </template>
        <template v-slot:item.options="{ item }">
          <v-tooltip bottom>
            <template v-slot:activator="{ on }">
              <v-btn icon @click.native.stop="removeItem(item)" v-on="on">
                <v-icon color="red">delete</v-icon>
              </v-btn>
            </template>
            <span>{{ $t('Odstranit položku') }}</span>
          </v-tooltip>
        </template>
        <template v-slot:item.totalPrice="{ item }">{{ item.useCredit ? item.totalCredit : item.total | currency }}
          <br>
          <small>{{ item.useCredit ? $t('Kredit') : $t('Cena') }}</small>
        </template>
        <template v-slot:body.append="{ isMobile }">
          <tr v-for="(card, index) in cardsTotalCredit" :key="index">
            <template v-if="isMobile">
              <td class="v-data-table__mobile-row">
                <div class="v-data-table__mobile-row__wrapper">
                  <div class="v-data-table__mobile-row__header">
                    {{ $t('Dostupný kredit ' + displayedCardNo(card.cardId)) }}
                  </div>
                  <div class="v-data-table__mobile-row__cell">
                    {{ card.availableCredit + chargedCredit(card) | currency }}
                  </div>
                </div>
              </td>
              <td class="v-data-table__mobile-row">
                <div class="v-data-table__mobile-row__wrapper">
                  <div class="v-data-table__mobile-row__header">
                    {{ $t('Použitý kredit') }}
                  </div>
                  <div class="v-data-table__mobile-row__cell">
                    <v-btn v-if="card.credit - card.availableCredit - chargedCredit(card) > 0" text color="primary"
                           @click="rechargeCredit(card.cardId)">{{ $t('Dobít') }}
                      {{ (card.credit - card.availableCredit) - chargedCredit(card) | currency }}
                    </v-btn>
                    {{ -card.credit | currency }}
                  </div>
                </div>
              </td>
            </template>
            <template v-else>
              <td>
                <strong>{{ $t('Karta') + ': ' + displayedCardNo(card.cardId) }}</strong>
                <br><small>{{ validCard(card.cardId).mainRate ? validCard(card.cardId).mainRate.name : '' }}</small>
              </td>
              <td class="text-right">
                <strong>{{ card.availableCredit + chargedCredit(card) | currency }}</strong>
                <br><small>{{ $t('Dostupný kredit') }}</small>
              <td>
              </td>
              <td>
                <v-btn v-if="card.credit - card.availableCredit - chargedCredit(card) > 0" text color="primary"
                       @click="rechargeCredit(card.cardId)">{{ $t('Dobít') }}
                  {{ (card.credit - card.availableCredit) - chargedCredit(card) | currency }}
                </v-btn>
              </td>
              <td class="text-right">
                <strong>{{ -card.credit | currency }}</strong>
                <br><small>{{ $t('Použitý kredit') }}</small>
              </td>
            </template>
          </tr>
          <!--
        <tr v-if="cardsTotalCredit.filter(c => c.credit - c.availableCredit - chargedCredit(c) > 0).length > 1">
          <td>
            <strong>{{ $t('Celkový kredit') }}</strong>
          </td>
          <td class="text-right">
            <strong>{{ availableCredit + chargedCredit() | currency }}</strong>
            <br><small>{{ $t('Dostupný kredit') }}</small>
          </td>
          <td></td>
          <td>
            <template v-if="totalCredit - availableCredit - chargedCredit() > 0">
              <v-row>
                <v-btn text color="primary" @click="rechargeCredit()">{{ $t('Dobít') }} {{ (totalCredit - availableCredit) - chargedCredit() | currency }}</v-btn>
              </v-row>
            </template>
          </td>
          <td class="text-right">
          </td>
        </tr>
        -->
          <tr>
            <template v-if="isMobile">
              <td class="v-data-table__mobile-row">
                <div class="v-data-table__mobile-row__wrapper">
                  <div class="v-data-table__mobile-row__header">
                    {{ $t('Cena k úhradě') }}
                  </div>
                  <div class="v-data-table__mobile-row__cell">
                    <v-btn text color="primary" @click="refreshBasket()">{{ $t('Přepočítat') }}</v-btn>
                    <strong>{{ totalPrice | currency }}</strong>
                  </div>
                </div>
              </td>
            </template>
            <template v-else>
              <td colspan="3">
                <strong>{{ $t('Cena') }}</strong>
              </td>
              <td>
                <v-btn text color="primary" @click="refreshBasket()">{{ $t('Přepočítat') }}</v-btn>
              </td>
              <td class="text-right">
                <strong>{{ totalPrice | currency }}</strong>
                <br>
                <small>{{ $t('Cena k úhradě') }}</small>
              </td>
            </template>
          </tr>
        </template>
      </v-data-table>
      <v-container fluid mt-5 class="text-center">
        <v-row>
          <v-col>
            <v-btn color="primary" to="/reservation" v-if="this.lastItem.itemType === 'reservation'">
              <v-icon>store</v-icon>
              <span>{{ $t('Pokračovat do rezervací') }}</span>
            </v-btn>
            <v-btn color="primary" to="/eshop" v-else>
              <v-icon>store</v-icon>
              <span>{{ $t('Pokračovat do obchodu') }}</span>
            </v-btn>
          </v-col>
          <v-col>
            <v-btn color="primary" :disabled="!hasItems || necessaryCredit > 0" to="/payment">
              <v-icon>credit_card</v-icon>
              <span>{{ $t('Dokončit nákup') }}</span>
            </v-btn>
          </v-col>
        </v-row>
      </v-container>
    </v-card>
  </div>
</template>
<script>
import BasketMixin from '@/mixins/basket-mixin.js'
import CustomerMixin from '@/mixins/customer-mixin.js'
import TransformMixin from '@gravela/vue-component-library/src/mixins/transform-mixin.js'

export default {
  mixins: [BasketMixin, CustomerMixin, TransformMixin],
  data() {
    return {
      itemsPerPageOptions: [6, 12, 18],
      expanded: [],
      headers: [{
        text: 'Položka',
        value: 'itemName',
        sortable: true
      }, {
        text: 'Částka',
        value: 'price',
        align: 'right',
        sortable: false
      }, {
        text: 'Množství',
        value: 'volume',
        align: 'center',
        sortable: false
      }, {
        text: 'Možnosti',
        value: 'options',
        align: 'center',
        sortable: false
      }, {
        text: 'Celkem',
        value: 'totalPrice',
        align: 'right',
        sortable: false
      }]
    }
  },
  computed: {
    creditableCards() {
      return this.customer.cards ? this.customer.cards.filter(c => !c.isOneTimeCard && !c.blocked) : []
    },
    selectedCard() {
      return this.creditableCards.length > 0 ? this.creditableCards[0] : null
    }
  },
  methods: {
    onChange(value) {
      this.$emit('input', value)
    },
    volumeChanged(currentBasketItem) {
      if (currentBasketItem.volume <= 0) {
        currentBasketItem.volume = 1
      }
    },
    rechargeCredit(cardId) {
      this.rechargeCard(cardId)
    }
  }
}
</script>
